import { useStreamingStore } from '@/store/streaming';
import { Button } from '@nf/ui';
import { matchEquals } from '@nf/utils-common/fpw/monadic';
import { usePathname, useRouter } from '@/navigation';
import { ArrowLeftIcon } from '@/components/icons/svg-icons';
import { useTranslations } from 'next-intl';
import { useSearchParams } from 'next/navigation';
import { setKafkaStreaming } from '@/hooks/query/use-kafka-log';
import { getKafkaStreamerType } from '@/utils/common-util';
import { StreamingKafkaNote } from '@nf/utils-common/constants';
import { useAnalyseAttribute } from '@/features/next-analyse';


export const BackButton = ({ isSingleMatch = false, isAsideLayout = false }: { isSingleMatch?: boolean, isAsideLayout?: boolean }) => {
	const t = useTranslations('General');
	const [setStreamingStatus, 
		streamingType,
		streamingPluginUrl,
		setStreamingPluginUrl,
	] = useStreamingStore(
		state => [
			state.setStreamingStatus,
			state.streamingType,
			state.streamingPluginUrl,
			state.setStreamingPluginUrl,
		]
	);
	const pathName = usePathname();
	const router = useRouter();
	const searchParams = useSearchParams();
	const analyseAttributeRef = useAnalyseAttribute('back-from-single-match');
	
	const handleBack = () => {
		streamingPluginUrl && streamingType && setStreamingPluginUrl('')
		//promotion widget
		if (localStorage.getItem('widgetRouter')) {
			const widgetType = localStorage.getItem('widgetRouter');
			if (['group', 'country', 'knockout'].includes(widgetType ?? '')) {
				router.push(`/promotion/widget/${widgetType}`);
				localStorage.removeItem('widgetRouter');
				return;
			}
		}
		const streamerKafkaData = {
			note: StreamingKafkaNote.SingleMatch,
			type: 8,
			action: 2,
			matchId: 0,
			streamer_type: getKafkaStreamerType(0)
		};
		setKafkaStreaming(streamerKafkaData);
		
		const oddsPageHref = matchEquals(pathName.split('/').slice(1, 2).join('/'))
			.on('sports', () => `${pathName.split('/').slice(0, -2).join('/')}`)
			.on('live', () => `${pathName.split('/').slice(0, -2).join('/')}`)
			.on('world', () => `/${pathName.split('/').slice(1, -2).join('/')}`)
			.otherwise(() => `/${pathName.split('/').slice(2, -2).join('/')}`);
		setStreamingStatus('', '', []);
		router.push(`${oddsPageHref}?${searchParams.toString()}`);
	}

	return (
		isSingleMatch ? (
			<button
				className="single-heading__back"
				onClick={handleBack}
			>
				<ArrowLeftIcon />
				<span>{t('lbl_Back')}</span>
			</button>
		) : !isAsideLayout ? (
			<Button
				ref={analyseAttributeRef}
				variant={'icon'}
				onClick={handleBack}
			>
				<ArrowLeftIcon />
			</Button>
		) : null
	)
};